import { Component, Input, OnInit, ViewChild, ElementRef } from '@angular/core';
import { UserserviceService } from '../userservice.service';
import { SidebarService } from '../sidebar.service';

import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { LoaderService } from '../loader.service';
import { ModelserviceService } from '../modelservice.service';
import { popup } from '../popup';
import { TranlationService } from '../tranlation.service';
import { translatedData } from '../dashboard';
// import { TranlationService } from '../tranlation.service';
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {
    imageUrl: any = '';
    uid: any;
    language: any;
    data: any;
    currentLink: any = '';
    name: any = '';
    shortname: any = '';
    menuOpen = false;
    titlesOpen = false;
    accountOpen = false;

    translatedData1 = translatedData;
    dashbaordData = this.translatedData1.dashboard;
    constructor(
        private translator: TranlationService,
        private userService: UserserviceService,
        private router: Router,
        private loader: LoaderService,
        private openModel: ModelserviceService,
        private side: SidebarService
    ) {
        this.language = localStorage.getItem('lang');
        if (this.language == undefined || this.language == null) {
            this.language = 'en';
            localStorage.setItem('lang', this.language);
        }
        this.translation();
        this.loader.updateVideo$.subscribe(() => {
            console.log('refresh titles');
            this.getData();
        });
        this.router.events.subscribe((event) => {
            if (!(event instanceof NavigationEnd)) {
                return;
            }

            const url = event.urlAfterRedirects || event.url;

            // Helper to build "Dashboard/Section/Title" style breadcrumbs
            const buildWithTitle = async (
                sectionLabel: string,
                useFileTitle: boolean
            ) => {
                const uid = localStorage.getItem('uid')?.toString() || '';
                const wid = localStorage.getItem('currentTitle') || '';

                if (!uid || !wid) {
                    this.currentLink = `Dashboard/${sectionLabel}`;
                    return;
                }

                try {
                    if (useFileTitle) {
                        const segments = url.split('/');
                        const fileId = segments[segments.length - 1];
                        const fileData = await this.userService.getFileDatas(
                            uid,
                            wid,
                            fileId
                        );
                        const rawName =
                            (fileData && (fileData as any).fileName) || fileId;
                        const displayName = rawName.replace(/\.[^/.]+$/, '');
                        this.currentLink = `Dashboard/${sectionLabel}/${displayName}`;
                    } else {
                        // Get workspace data by fetching all workspaces and finding the matching one
                        const workspaces = await this.userService.getWorkspaces(
                            uid
                        );
                        const workspace = workspaces.find(
                            (w: any) => w.id === wid
                        );
                        const titleName =
                            workspace?.title ||
                            workspace?.workspaceTitle?.title ||
                            wid;
                        this.currentLink = `Dashboard/${sectionLabel}/${titleName}`;
                    }
                } catch {
                    this.currentLink = `Dashboard/${sectionLabel}`;
                }
            };

            if (url.startsWith('/dashboard/video-page')) {
                // Dashboard/Video Page/<File Title>
                buildWithTitle('Video Page', true);
            } else if (url.startsWith('/dashboard/ocr-edit-page')) {
                // Dashboard/Ocr Edit Page/<File Title>
                buildWithTitle('Ocr Edit Page', true);
            } else if (url.startsWith('/dashboard/dialog-sheet-editor')) {
                // Dashboard/Dialog Sheet Editor/<File Title>
                buildWithTitle('Dialog Sheet Editor', true);
            } else if (url.startsWith('/dashboard/title')) {
                // Dashboard/Title/<Workspace Title>
                buildWithTitle('Title', false);
            } else if (url.startsWith('/dashboard/metadata')) {
                // Dashboard/Metadata/<Workspace Title>
                buildWithTitle('Metadata', false);
            } else if (url.startsWith('/dashboard/member')) {
                // Dashboard/Member/<Workspace Title>
                buildWithTitle('Member', false);
            } else if (url.startsWith('/dashboard/order-history')) {
                // Dashboard/Order History/<Workspace Title>
                buildWithTitle('Order History', false);
            } else {
                // Default behaviour for all other routes
                this.currentLink = this.capitalizeFirstLetter(
                    url.slice(1).replace(/-/g, ' ')
                );
                if (this.currentLink == '/Dashboard') {
                    this.currentLink = '';
                }
            }
        });
    }
    navigation = translatedData.navigation;

    dropDown: any[] = [];
    openDropdown(id: any) {
        this.dropDown.map((x: any) => {
            if (x.data.id == id && x.data.status == 0) {
                x.data.status = 1;
                localStorage.setItem('currentTitle', id);
            } else {
                x.data.status = 0;
            }
        });
    }

    // switchLanguage(language: string) {
    //   this.translate.use(language);
    // }

    toggleMenu() {
        this.menuOpen = !this.menuOpen;
    }
    closeMenu() {
        this.menuOpen = false;
        this.titlesOpen = false;
        this.accountOpen = false;
    }

    toggleTitles() {
        this.titlesOpen = !this.titlesOpen;
    }

    toggleAccount() {
        this.accountOpen = !this.accountOpen;
    }

    hideSideBar() {
        if (window.innerWidth < 768) {
            this.side.hideSidebar();
        }
    }

    logout() {
        this.closeModal1();
        this.logout();
    }

    @ViewChild('modalCloseButton1') modalCloseButton1!: ElementRef;

    closeModal1() {
        const button: any = this.modalCloseButton1.nativeElement;
        button.click();
    }

    capitalizeFirstLetter(str: any) {
        return str.replace(/\b\w/g, function (char: any) {
            return char.toUpperCase();
        });
    }

    lang: any;
    async ngOnInit() {
        this.translator.translationData$.subscribe((data) => {
            if (data) {
                this.dashbaordData = data.dashboard;
                this.navigation = data.navigation;
                this.loader.hide();
            }
        });
        this.uid = localStorage.getItem('uid')?.toString();
        this.getData();
    }

    changeLanguage(event: Event) {
        this.loader.show();
        this.language = (event.target as HTMLInputElement).value;
        localStorage.setItem('lang', this.language);
        console.log(this.translatedData1);
        this.translation();
    }
    base: string = './assets/language/';
    url: string = '';

    translation() {
        switch (this.language) {
            case 'hi':
                this.url = `${this.base}hindi.json`;
                break;
            case 'zh-CN':
                this.url = `${this.base}mandarin.json`;
                break;
            case 'ko':
                this.url = `${this.base}korean.json`;
                break;
            case 'es':
                this.url = `${this.base}spanish.json`;
                break;
            case 'fr':
                this.url = `${this.base}french.json`;
                break;
            case 'ja':
                this.url = `${this.base}japanese.json`;
                break;
            case 'pt':
                this.url = `${this.base}portuguese.json`;
                break;
            case 'it':
                this.url = `${this.base}italian.json`;
                break;
            default:
                this.url = 'english.json';
                break;
        }
        if (this.url == 'english.json') {
            console.log(this.translatedData1);
            this.translator.loadTranslationData(this.translatedData1);
        } else {
            console.log(this.url, 'url');
            this.translator.readJsonFile(this.url).subscribe({
                next: (res) => {
                    this.translator.loadTranslationData(res);
                    console.log(res, 'get hindi data');
                    // this.saveToFile(res,'italian.json')
                    // localStorage.setItem('static',JSON.stringify(res))
                    this.loader.hide();
                },
                error: (err) => {
                    console.log(err);
                    this.loader.hide();
                },
            });
        }

        // this.translator.translateObject(this.translatedData1,this.language).subscribe({
        //   next:(res)=>{
        //     this.translator.loadTranslationData(res)
        //     console.log(res)
        //     this.saveToFile(res,'italian.json')
        //     localStorage.setItem('static',JSON.stringify(res))
        //      this.loader.hide()
        //   },
        //   error:(err)=>{
        //     console.log(err)
        //     this.loader.hide()

        //   }
        // })
        console.log('language change');
    }

    switchCase() {
        switch (this.language) {
            case 'hi':
                return 'hindi.json';
            case 'zh-CN':
                return 'mandarin.json';
            case 'ko':
                return 'korean.json';
            case 'es':
                return 'spanish.json';
            case 'fr':
                return 'french.json';
            case 'ja':
                return 'japanese.json';
            case 'pt':
                return 'portuguese.json';
            case 'it':
                return 'italian.json';
            default:
                return 'english.json';
        }
    }

    // async loadFromCloud(): Promise<void> {
    //   try {
    //     const lang = this.switchCase();
    //     console.log(lang, 'file name');

    //     const translatedObject = await this.translator.translateObject(this.translatedData1, this.language).toPromise();
    //     console.log(translatedObject,'translatedObject')
    //     this.saveToFile(translatedObject,lang)
    //   } catch (error) {
    //     console.error(error);
    //   }
    // }

    saveToFile(data: any, filename: string): void {
        const jsonString = JSON.stringify(data);

        // Create blob from JSON string
        const blob = new Blob([jsonString], { type: 'application/json' }); // Use 'application/json' type for JSON files

        // Create anchor element to trigger download
        const anchor = document.createElement('a');
        anchor.download = filename;
        anchor.href = window.URL.createObjectURL(blob);
        anchor.click();
    }

    customerDetails: any;
    getData() {
        this.userService
            .getDetailsData(this.uid)
            .then((result) => {
                this.customerDetails = result;
                if (result.firstName != undefined) {
                    this.name = `${result.firstName} ${result.lastName}`;
                    this.shortname = `${result.firstName[0]}${result.lastName[0]}`;
                } else {
                    this.name = result.email.split('@')[0];
                    this.shortname = `${this.name[0]}`;
                    console.log(this.shortname);
                }
                this.getAllWorkspaces(this.uid);
            })
            .catch((err) => {
                console.log(err);
            });
    }
    handleImageError() {
        this.imageUrl = '';
    }

    getAllWorkspaces(uid: any) {
        this.dropDown = [];
        this.userService
            .getWorkspaces(uid)
            .then((result) => {
                result.map((x: any) => {
                    this.dropDown.push({ role: 'Admin', data: x });
                });
                this.getMemberWorkspace();
            })
            .catch((err) => {
                console.log(err);
            });
    }

    workspace: any;
    role: any = '';
    async getMemberWorkspace() {
        this.workspace = this.customerDetails?.workspaces;
        this.workspace?.map(async (element: any) => {
            const role = element.role;
            await this.userService
                .getMemberWorkspace(element.userAccessuid, element.workspaceId)
                .then((result) => {
                    if (result != null) {
                        this.dropDown.push({ role: role, data: result });
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        });
    }
}
